import React, { useMemo, useState } from 'react';
import { IFilterType } from '../../../../../../types/ProfileTypes';
import { AnchorButton } from '@blueprintjs/core';
import { ISelectItem } from '../../../../../../types/ItemSelectType';
import { ButtonGroupStyled } from '../styled';
import { uniqueId } from 'lodash';
import { useMeasure } from 'react-use';

export const GroupButtons = (props: { disabled: boolean; filter: IFilterType; onChange: (value: any) => void }) => {
  const { disabled, filter, onChange } = props;
  const [buttons] = useState<ISelectItem[]>(filter?.source ?? []);
  const [refContainer, { width }] = useMeasure();

  const onClick = (value: any) => () => {
    onChange(value);
  };

  const getIntent = (value: any): 'danger' | 'none' => {
    return filter.value === value ? 'danger' : 'none';
  };

  const repeat = useMemo(() => {
    if (buttons.length <= 2) {
      return `repeat(1, 100%)`;
    }
    if (buttons.length <= 4) {
      return `repeat(2, 50%)`;
    }
    return `repeat(3, 33.33%)`;
  }, [buttons]);

  return (
    <ButtonGroupStyled ref={refContainer} width={width} repeat={repeat}>
      {buttons.map((item: ISelectItem) => (
        <AnchorButton
          className={'buttons-group-filters'}
          key={uniqueId()}
          intent={getIntent(item.value)}
          text={item.label}
          disabled={disabled}
          minimal
          outlined
          onClick={onClick(item.value)}
        />
      ))}
    </ButtonGroupStyled>
  );
};
